import type { ICardPaymentMethod } from "../interfaces/payment-method";

export type CardFundingKind = "DEBIT_CARD" | "CREDIT_CARD";

export type UnavailableCardReason =
  | "creditOnDebitRoute"
  | "debitOnCreditRoute"
  | "generic"
  | "railRejected"
  | "railTemporarilyUnavailable";

/** Saved cards without `fundingMethod` follow the debit default used at pick. */
export const cardFundingKind = (
  card: Pick<ICardPaymentMethod, "fundingMethod">
): CardFundingKind =>
  card.fundingMethod === "CREDIT_CARD" ? "CREDIT_CARD" : "DEBIT_CARD";

export const isCardFundingAvailable = (
  card: Pick<ICardPaymentMethod, "fundingMethod">,
  available: readonly string[]
): boolean => available.includes(cardFundingKind(card));

export const unavailableCardReason = (
  card: Pick<ICardPaymentMethod, "fundingMethod">,
  available: readonly string[]
): UnavailableCardReason => {
  const kind = cardFundingKind(card);
  const hasDebit = available.includes("DEBIT_CARD");
  const hasCredit = available.includes("CREDIT_CARD");
  if (kind === "CREDIT_CARD" && hasDebit && !hasCredit) {
    return "creditOnDebitRoute";
  }
  if (kind === "DEBIT_CARD" && hasCredit && !hasDebit) {
    return "debitOnCreditRoute";
  }
  return "generic";
};
